<template>
  <el-dialog :visible.sync="isVisible" width="40%" :before-close="cancel">
    <div class="call-content">
      <div class="title">与{{ target.caseContent_dictText.name }}视频聊天</div>
      <div class="avatar-warpper">
        <img :src="targetAvatar | headerFilter" />
      </div>
      <div class="check-warpper">
        <el-checkbox
          label="视频时打开摄像头"
          @change="deviceVideoAgree"
          style="margin-right: 0"
          checked
        ></el-checkbox>
        <el-checkbox
          label="视频时打开麦克风"
          @change="deviceMicAgree"
          checked
        ></el-checkbox>
      </div>
      <div class="footer">
        <el-button class="btn" type="primary" round @click="sure"
          >视频问诊</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    target: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    visible() {
      this.getUserInfo();
      this.isVisible = this.visible;
    },
  },
  filters: {
    headerFilter: function (img) {
      if (img) {
        return img;
      } else {
        return require("../../../assets/images/default-avatar-doctor.png");
      }
    },
  },
  created() {
    this.getUserInfo();
    console.log(this.target)
    this.isVisible = this.visible;
  },
  data() {
    return {
      type: [1, 2],
      isVisible: false,
      targetAvatar: "",
    };
  },
  methods: {
    getUserInfo() {
      this.$store
        .dispatch("getUserInfo", this.target.imAccid)
        .then((res) => {
          this.targetAvatar = res.avatar;
        })
        .catch((err) => {
          this.$message("登录信息错误，请检查后重试");
        });
    },
    sure() {
      this.$emit("on-inter-room", this.type);
    },
    cancel() {
      this.isVisible = false;
      this.$emit("update:visible", this.isVisible);
    },
    deviceVideoAgree(value) {
      const index = this.type.indexOf(1);
      if (value && index === -1) {
        this.type.push(1);
      } else {
        this.type.splice(index, 1);
      }
    },
    deviceMicAgree(value) {
      const index = this.type.indexOf(2);
      if (value && index === -1) {
        this.type.push(2);
      } else {
        this.type.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.call-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    font-size: 16px;
    color: #000;
  }
  .avatar-warpper {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    margin: 20px 0;
    img {
      width: 100%;
    }
  }
  .check-warpper {
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .footer {
    width: 100%;
    text-align: center;
    .btn {
      width: 60%;
    }
  }
}
</style>